import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class F1MeetingStore extends LocalModel {
    constructor() {
        super('f1Meeting', {
            namePlural: 'f1Meetings',
            namePluralReal: 'f1meetings',
            sort: '-dateStart',
            limit: 100,
            api: {
                search: {
                    url: '/api/f1meetings/',
                    params: {
                        limit: 100,
                        sort: '-dateStart',
                    },
                },
                load: {
                    url: '/api/f1meetings/',
                    params: {},
                },
                save: {
                    url: '/api/f1meetings/',
                    params: {},
                },
                delete: {
                    url: '/api/f1meetings/',
                    params: {},
                },
            },
        });
    }

    @observable f1Meetings = [];

    @observable f1Meeting = {};

    @observable newF1Meeting = {};
}

const store = new F1MeetingStore();
export default store;
